import React, { useState, useEffect, useRef, useCallback } from "react";

import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";
import InfoIcon from '@material-ui/icons/Info';

import { makeStyles, useTheme } from "@material-ui/core/styles";
import { toast } from "react-toastify";

import TableAttendantsStatus from "../../components/Dashboard/TableAttendantsStatus";
import { isArray } from "lodash";

import useDashboard from "../../hooks/useDashboard";
import useCompanies from "../../hooks/useCompanies";

import moment from "moment";
import SquarePhoneIcon from "../../assets/icon/SquarePhoneIcon";
import SquareChatingIcon from "../../assets/icon/SquareChatingIcon";
import SquareSuccesIcon from "../../assets/icon/SquareSuccesIcon";
import SquareClockIcon from "../../assets/icon/SquareClockIcon";
import SquareCoffeIcon from "../../assets/icon/SquareCoffeIcon";
import { Button, IconButton } from "@material-ui/core";
import DownArrow from "../../assets/icon/DownArrow";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import CustomChart from "./Chart";
import 'moment/locale/es';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4, 0, 4, 0),
    margin: theme.spacing(0, 5, 0, 5),
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 240,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardAvatar: {
    fontSize: "40px",
    color: "#ffffff",
    backgroundColor: "transparent",
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginBottom: theme.spacing(1),
  },
  cardTitle: {
    fontSize: "16px",
    color: "#ffffff",
    fontWeight: 500,
  },
  cardSubtitle: {
    color: "#ffffff",
    fontSize: "20px",
    fontWeight: 600,
  },
  fullWidth: {
    width: "100%",
  },
  containerFilter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(0.5),
    borderRadius: "12px",
    backgroundColor: theme.palette.inputBackground,
    width: "100%",
    "& > *": {
      "&:last-child": {
        marginLeft: "auto",
      },
    },
  },
  leftSection: {
    display: "flex",
    gap: theme.spacing(2),
    alignItems: "center",
    flexGrow: 1,
  },
  formControl: {
    backgroundColor: "transparent",
    marginTop: theme.spacing(2),
    color: "#fff",
    borderRadius: "8px",
    minWidth: "200px",
    "& .MuiInputLabel-outlined": {
      color: "#888",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  datePicker: {
    marginTop: theme.spacing(2),
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiInputLabel-outlined": {
      color: "#888",
    },
    "& .MuiInputBase-input": {
      color: theme.palette.text,
      "&::-webkit-calendar-picker-indicator": {
        display: "none",
      },
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    flexGrow: 0,
  },
  buttonFilter: {
    backgroundColor: "transparent",
    color: "#d4af37",
    border: "1px solid #d4af37",
    padding: theme.spacing(1, 2),
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "#d4af37",
      color: "#000",
    },
  },
  cardCommon: {
    padding: theme.spacing(4, 0, 4, 2),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "100%",
    borderRadius: "12px",
    backgroundColor: theme.palette.inputBackground,
    color: theme.palette.text.secondary,
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const theme = useTheme();
  const [counters, setCounters] = useState({});
  const [attendants, setAttendants] = useState([]);
  const [filterType, setFilterType] = useState(1);
  const [period, setPeriod] = useState(0);
  const [companyDueDate, setCompanyDueDate] = useState();
  const [value, setValue] = useState('periodo');
  const [dateFrom, setDateFrom] = useState(
    moment("1", "D").format("YYYY-MM-DD")
  );
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const { find } = useDashboard();
  const { finding } = useCompanies();
  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const currentDay = new Date();
  const [startDate, setStartDate] = useState(firstDayOfMonth);
  const [endDate, setEndDate] = useState(currentDay);

  useEffect(() => {
    fetchData();
  }, [period, startDate, endDate]);

  const handleChangePeriod = useCallback((value) => {
    const periodValue = value.target.value ?? 'periodo';
    console.log('Valor del periodo', periodValue)
    setPeriod(periodValue);
  }, []);

  async function handleChangeFilterType(value) {
    setFilterType(value);
    if (value === 1) {
      setPeriod(0);
    } else {
      setDateFrom("");
      setDateTo("");
    }
  }

  async function fetchData() {
    setLoading(true);

    let params = {};

    if (period > 0) {
      params = {
        days: period,
      };
    }

    if (moment(startDate).isValid()) {
      params = {
        ...params,
        date_from: moment(startDate).format("YYYY-MM-DD"),
      };
    }

    if (moment(endDate).isValid()) {
      params = {
        ...params,
        date_to: moment(endDate).format("YYYY-MM-DD"),
      };
    }

    if (Object.keys(params).length === 0) {
      toast.error("Parametrize o filtro");
      setLoading(false);
      return;
    }

    const data = await find(params);

    setCounters(data.counters);
    if (isArray(data.attendants)) {
      setAttendants(data.attendants);
    } else {
      setAttendants([]);
    }

    setLoading(false);
  }

  useEffect(() => {
    loadCompanies();
  }, []);

  const handleStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
  };

  const companyId = localStorage.getItem("companyId");
  const loadCompanies = async () => {
    setLoading(true);
    try {
      const companiesList = await finding(companyId);
      setCompanyDueDate(moment(companiesList.dueDate).format("DD/MM/yyyy"));
    } catch (e) {
      console.log("🚀 Console Log : e", e);
    }
    setLoading(false);
  };

  function formatTime(minutes) {
    if (minutes === null || minutes === undefined || isNaN(minutes)) {
      return "0h 0m 0s";
    }

    const totalSeconds = Math.round(minutes * 60);

    const hours = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    return `${hours}h ${mins}m ${secs}s`;
  }

  // const renderDateFilters = () => (
  //   <>
  //     <Grid item xs={12} sm={6} md={4}>
  //       <TextField
  //         label="Fecha Inicial"
  //         type="date"
  //         value={dateFrom}
  //         onChange={(e) => setDateFrom(e.target.value)}
  //         className={classes.fullWidth}
  //         InputLabelProps={{ shrink: true }}
  //       />
  //     </Grid>
  //     <Grid item xs={12} sm={6} md={4}>
  //       <TextField
  //         label="Fecha Final"
  //         type="date"
  //         value={dateTo}
  //         onChange={(e) => setDateTo(e.target.value)}
  //         className={classes.fullWidth}
  //         InputLabelProps={{ shrink: true }}
  //       />
  //     </Grid>
  //   </>
  // );

  // const renderPeriodFilters = () => (
  //   <Grid item xs={12} sm={6} md={4}>
  //     <FormControl className={classes.selectContainer}>
  //       <InputLabel id="period-selector-label">Período</InputLabel>
  //       <Select
  //         labelId="period-selector-label"
  //         id="period-selector"
  //         value={period}
  //         onChange={(e) => handleChangePeriod(e.target.value)}
  //       >
  //         <MenuItem value={0}>Ninguno seleccionado</MenuItem>
  //         <MenuItem value={3}>Últimos 3 días</MenuItem>
  //         <MenuItem value={7}>Últimos 7 días</MenuItem>
  //         <MenuItem value={15}>Últimos 15 días</MenuItem>
  //         <MenuItem value={30}>Últimos 30 días</MenuItem>
  //         <MenuItem value={60}>Últimos 60 días</MenuItem>
  //         <MenuItem value={90}>Últimos 90 días</MenuItem>
  //       </Select>
  //       <FormHelperText>Seleccione el período deseado</FormHelperText>
  //     </FormControl>
  //   </Grid>
  // );

  // const renderFilters = () =>
  //   filterType === 1 ? renderDateFilters() : renderPeriodFilters();

  const renderStatisticCard = (title, value, icon) => (
    <Grid item xs={12} sm={6} md style={{ flexGrow: 1 }}>
      <Paper className={classes.cardCommon} style={{ overflow: "hidden", padding: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {icon}
            <Typography
              component="h3"
              variant="h6"
              style={{ fontSize: 15 }}
            >
              {title}
            </Typography>
          </div>
          <InfoIcon style={{ opacity: 0.6, cursor: "pointer" }} />
        </div>

        <Typography
          component="h1"
          variant="h4"
          style={{
            fontWeight: "bold",
            color: theme.palette.text.primary,
            fontSize: 33,
            marginTop: 10,
          }}
        >
          {value}
        </Typography>
      </Paper>
    </Grid>
  );

  useEffect(() => {
    // Configurar moment en español
    moment.locale('es');
  }, []);

  return (
    <div className={classes.container}>
      <Grid container spacing={1}>
        <Grid container spacing={2} className={classes.containerFilter} style={{ marginRight: 0, marginLeft: 0 }}>
          {/* Select */}
          <Grid item xs={12} sm={12} md={4} lg={3}>
            <FormControl variant="outlined" fullWidth className={classes.formControl}>
              <InputLabel id="filter-type-label">Periodo por tiempo</InputLabel>
              <Select
                disabled
                labelId="filter-type-label"
                value={period}
                onChange={handleChangePeriod}
                label="Periodo por tiempo"
                className={classes.select}
                MenuProps={{
                  classes: {
                    paper: classes.paper,
                    list: classes.list,
                  },
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  transformOrigin: {
                    vertical: 'top',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
              >
                <MenuItem value={0}>Filtro por fecha</MenuItem>
                <MenuItem value={1}>Período por tiempo</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {/* Fechas */}
          <Grid item xs={12} sm={12} md={8} lg={4}>
            <MuiPickersUtilsProvider utils={MomentUtils} locale="es">
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <KeyboardDatePicker
                    fullWidth
                    variant="inline"
                    format="DD/MM/YYYY"
                    margin="normal"
                    label="Fecha inicial"
                    value={startDate}
                    onChange={handleStartDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "cambiar fecha"
                    }}
                    cancelLabel="Cancelar"
                    okLabel="Aceptar"
                    invalidDateMessage="Fecha inválida"
                    maxDateMessage="La fecha no puede ser posterior a la máxima"
                    minDateMessage="La fecha no puede ser anterior a la mínima"
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: (
                        <IconButton size="small">
                          <DownArrow />
                        </IconButton>
                      ),
                    }}
                    InputLabelProps={{
                      style: { color: "#888" },
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <KeyboardDatePicker
                    fullWidth
                    variant="inline"
                    format="DD/MM/YYYY"
                    margin="normal"
                    label="Fecha final"
                    value={endDate}
                    onChange={handleEndDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "cambiar fecha"
                    }}
                    cancelLabel="Cancelar"
                    okLabel="Aceptar"
                    invalidDateMessage="Fecha inválida"
                    maxDateMessage="La fecha no puede ser posterior a la máxima"
                    minDateMessage="La fecha no puede ser anterior a la mínima"
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: (
                        <IconButton size="small">
                          <DownArrow />
                        </IconButton>
                      ),
                    }}
                    InputLabelProps={{
                      style: { color: "#888" },
                    }}
                  />
                </Grid>

              </Grid>
            </MuiPickersUtilsProvider>
          </Grid>

          {/* Botón */}
          <Grid item xs={12} sm={12} md={2} lg={1}>
            <Button
              fullWidth
              variant="outlined"
              className={classes.buttonFilter}
              onClick={fetchData}
            >
              Filtrar
            </Button>
          </Grid>
        </Grid>
        {renderStatisticCard(
          "En espera de atención",
          counters.supportPending,
          <SquarePhoneIcon />
        )}
        {renderStatisticCard(
          "Atendiendo ahora",
          counters.supportHappening,
          <SquareChatingIcon />
        )}
        {renderStatisticCard(
          "Finalizados",
          counters.supportFinished,
          <SquareSuccesIcon />
        )}
        {/* {renderStatisticCard(
          "Nuevos contactos",
          counters.leads,
          <SquareUserIcon />
        )} */}
        {renderStatisticCard(
          "Promedio de servicio",
          formatTime(counters.avgSupportTime),
          <SquareClockIcon />
        )}
        {renderStatisticCard(
          "Promedio en espera",
          formatTime(counters.avgWaitTime),
          <SquareCoffeIcon />
        )}

        <Grid item xs={12}>
          <div style={{ width: "100%", margin: "0 auto" }}>
            <CustomChart />
          </div>
        </Grid>

        <Grid item xs={12}>
          <div style={{ width: "100%", margin: "0 auto" }}>
            <CustomChart
              dateFrom={new Date(startDate).toISOString()}
              dateTo={new Date(endDate).toISOString()}
            />
          </div>
        </Grid>

        <Grid item xs={12}>
          {attendants.length > 0 && (
            <TableAttendantsStatus attendants={attendants} loading={loading} />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
